import React from "react";
import { Treaty_treaty } from "_graphql/queries/__generated__/Treaty";

type Props = {
  treaty: Treaty_treaty | null | undefined;
};

const TreatySurpluses = ({ treaty }: Props) => {
  return (
    <div className="bg-card-500 rounded-xl shadow-lg overflow-hidden">
      <div className="px-6 py-5 border-b border-gray-700/50">
        <h3 className="text-xl font-semibold text-primary">Treaty Surpluses</h3>
        <p className="mt-1 text-sm text-tertiary">
          Commission rates for each surplus layer
        </p>
      </div>
      <div className="p-6">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-700/50">
            <thead>
              <tr>
                <th className="px-4 py-3 text-left text-sm font-medium text-gray-300">
                  Surplus No.
                </th>
                <th className="px-4 py-3 text-left text-sm font-medium text-gray-300">
                  Commission (%)
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-700/50">
              {JSON.parse(treaty?.layer_limit || "[]")?.map(
                (surplus: any, index: number) => (
                  <tr
                    key={surplus.id}
                    className="hover:bg-gray-700/30 transition-colors"
                  >
                    <td className="px-4 py-3 text-sm text-primary">
                      {index + 1}
                    </td>
                    <td className="px-4 py-3 text-sm text-primary">
                      {surplus.commission || surplus.commision}
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default TreatySurpluses;
